import { BulkActionMenuItemInjectedProps, FilterValues, KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { CustomComponent } from "@kaltura/mediaspace-shared-ui";
import ActionsDropdown from "./actions-dropdown/ActionsDropdown";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";
import { BulkActionProps } from "../types";
import { useContext } from "react";
import { MediaCardContext } from "@kaltura/mediaspace-shared-media-list";

export interface ActionsBarProps {
    bulkButtonActions?: KmsTypeComponent<any, BulkActionProps>[];
    bulkMenuActions?: KmsTypeComponent<any, BulkActionMenuItemInjectedProps>[];
    entryIds: string[];
    onInvalidate: () => void;
    filterValues?: FilterValues;
}

const StyledContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

const formatData = (
    bulkButtonActions: KmsTypeComponent<any, BulkActionProps>[] = [],
    bulkMenuActions: KmsTypeComponent<any, BulkActionMenuItemInjectedProps>[] = [],
    isSmallScreen: boolean,
    displayActionsInline?: boolean
) => {
    if (isSmallScreen && !displayActionsInline) {
        // all items should appear only in the dropdown for small screens
        return {
            bulkButtonActions: [],
            bulkMenuActions,
        };
    }
    else {
        // items which appear in both buttons and menu-items lists
        // should be removed from the menu-items list
        const buttonItemsIds = bulkButtonActions.map((item) => item.props.id);
        return {
            bulkButtonActions,
            bulkMenuActions: bulkMenuActions.filter((menuItem) => !buttonItemsIds.includes(menuItem.props.id)),
        };
    }
};

/**
 * search results actions bar
 */
const ActionsBar = (props: ActionsBarProps) => {
    const { bulkButtonActions, bulkMenuActions, entryIds, onInvalidate, filterValues } = props;

    const { displayActionsInline } = useContext(MediaCardContext);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    const formattedData = formatData(bulkButtonActions, bulkMenuActions, isSmallScreen, displayActionsInline);

    return (
        <StyledContainer>
            {entryIds.length > 0
                && formattedData.bulkButtonActions?.map((component, index) => {
                    return (
                        <span className={"kms-ds-my-media-results-actions-button"} key={component.props.id + index}>
                            <CustomComponent
                                key={component.props.id}
                                component={component}
                                entryIds={entryIds}
                                reloadMedia={onInvalidate}
                            />
                        </span>
                    );
                })}
            {entryIds.length > 0 && formattedData.bulkMenuActions?.length > 0 && (
                <ActionsDropdown
                    menuItems={formattedData.bulkMenuActions}
                    entryIds={entryIds}
                    reloadMedia={onInvalidate}
                    filterValues={filterValues}
                />
            )}
        </StyledContainer>
    );
};

export default ActionsBar;
